<template>
  <div class="p-8 text-center">
    <h3 class="text-sm font-medium text-gray-900 dark:text-white">
      {{ $t("craftable-pro", "No items") }}
    </h3>
    <p class="mt-1 text-sm text-gray-500">
      {{ $t("craftable-pro", "Change filters or create a new item.") }}
    </p>
  </div>
</template>

<script setup lang="ts"></script>
